var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"el-slider__marks-text",staticStyle:{},on:{"click":function($event){$event.stopPropagation();return _vm.onMarkClick.apply(null, arguments)}}},[_vm._ssrNode(_vm._ssrEscape("\n  "+_vm._s(_vm.label)+"\n"))])
}
var staticRenderFns = []

export { render, staticRenderFns }